import { render, staticRenderFns } from "./ClientvisitList.vue?vue&type=template&id=a61e8f28"
import script from "./ClientvisitList.vue?vue&type=script&lang=js"
export * from "./ClientvisitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports